/* eslint semi: 1 */

import CommonOptionsMixin from '@/components/mixins/common-options-mixin';
import Canvas from '../player-data-canvas';

export default {
  name: 'player-setup-canvas',
  inject: [
    '$api'
  ],
  mixins: [CommonOptionsMixin],
  props: {
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    canvasType: {
      type: String,
      default: 'videowall'
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      canvas: new Canvas(this.$api),
      isFormDisabled: false,
      languageCode: navigator?.language ?? 'en',
      model: {
        name: ''
      },
      showInput: false,
      canvasTag: null,
      editable: true
    };
  },
  async mounted () {
    await this.checkForExistingCanvas();
    if (this.model.name === '') {
      this.showInput = true;
    }
  },
  watch: {
    editable (nVal) {
      this.showInput = nVal;
    },
    async width (nVal, oVal) {
      if (nVal !== oVal) {
        await this.checkForExistingCanvas();
      }
    },
    async height (nVal, oVal) {
      if (nVal !== oVal) {
        await this.checkForExistingCanvas();
      }
    }
  },
  computed: {
    canvasSize () {
      if (!this.width || !this.height) {
        return null;
      }
      const formatter = new Intl.NumberFormat(this.languageCode);
      return `${formatter.format(this.width)} x ${formatter.format(this.height)}`;
    },
    formError () {
      if (this.error) {
        return 'Error';
      }
      return undefined;
    }
  },
  methods: {
    async checkForExistingCanvas () {
      if (!this.canvas) {
        throw new Error('canvas data property should be initialized with Canvas(this.$api) instance to properly function');
      }

      await this.$emit('canvasCheckInProgress', true);
      const canvasSize = `${this.width} ${this.height}`;
      const { ok: existingCanvas } = await this.canvas.findExistingCanvas(this.canvasType, canvasSize);
      const eraseCanvasName = !!this.canvasTag;

      // If yes, show cavas name (not editable), otherwise, show editable input
      if (existingCanvas) {
        this.model.name = existingCanvas.tag.name;
        this.canvasTag = existingCanvas.tag.value;
        this.editable = false;
      } else {
        // erase canvas name if there was existing canvas previously
        if (eraseCanvasName) {
          this.model.name = '';
        } else {
          this.model.name = this.model.name ?? '';
        }

        this.canvasTag = null;
        this.editable = true;
      }

      await this.$emit('updateCanvasInfo', this.model.name, this.canvasTag);
      await this.$emit('canvasCheckInProgress', false);
    },
    async triggerFormSubmit (event) {
      return false;
    },
    async handleInputOnChange () {
      // If input is empty, make the input stay and the div hidden
      // Emit updateCanvasInfo so sync with parent component
      if (this.model.name !== '') {
        this.showInput = false;
        await this.$emit('updateCanvasInfo', this.model.name, this.canvasTag);
      }
    },
    async handleEditIconOnClick () {
      this.showInput = true;

      await this.$nextTick();
      this.$refs.canvasNameInput.focus();
    }
  }
};
